/**
 * @toRemove
 * This will be removed once we finalise on the transition between the web and mobile apps for the cancel subscription journey and equivalent functionality
 * will be consumed from web-common-mobile-view-helpers package.
 */
import { isFlutterApp } from '@ecs-uk/web-common-mobile-view-helpers';

export enum CancelSubscriptionStep {
  BACK = 'back',
  CONFIRM_CANCELLATION = 'confirm',
  CANCELLATION_SUCCESS = 'success',
  GO_HOME = 'goHome',
}

export interface CSTransitionOptions {
  step: CancelSubscriptionStep;
  snackbarMessage?: string;
}

const cancelSubscriptionTransition = (csOptions: CSTransitionOptions): void => {
  if (!isFlutterApp()) {
    return;
  }

  (globalThis as any)?.cancelSubscriptionTransition?.postMessage(JSON.stringify(csOptions));
};

export default cancelSubscriptionTransition;
